<template>
	<nav id="navigation" class="md:absolute flex flex-col sm:flex-row p-6 top-0 w-full z-r">
		<transition-ease>
			<div 
				class="relative"
				v-if="route('home')"
				key="logo"
			>
				<router-link 
					class="md:absolute flex flex-row md:flex-col left-0 mb-6 sm:mb-0 top-0 z-r"

					:to="{ 
						name: 'home' 
					}" 
					exact
				>
					<h1 class="leading-none md:leading-11 text-2xl md:text-7xl text-red-9 md:w-min">
						salon anger
					</h1>

					<span class="ml-3 md:mt-4 text-2xl md:text-3xl text-gray-0">
						von Haar zu Haar
					</span>
				</router-link>
			</div>
			<div class="mb-6 sm:mb-0" key="link" v-else>
				<router-link 
					class="flex flex-col sm:flex-row"
					:to="{ 
						name: 'home' 
					}" 
					exact
				>
					<h1 class="text-2xl text-red-9">
						salon anger
					</h1>

					<span class="ml-3 text-2xl" :class="{'text-gray-0 md:text-gray-9' : route('contact') }">
						von Haar zu Haar
					</span>
				</router-link>
			</div>
		</transition-ease>
		<ul class="flex flex-1 flex-row items-center justify-center sm:justify-end list sm:ml-auto">
			<li class="uppercase px-3">
				<router-link
					class="text-2xl" 
					:class="{
						'text-gray-0 md:text-gray-9' : !route('home') 
					}" 

					:to="{ 
						name: 'salon' 
					}"
				>
					Geschäft
				</router-link>
			</li>
			<!-- <li>
				<router-link :to="{ name: 'jobs' }">
					Karriere
				</router-link>
			</li> -->
			<li class="uppercase px-3">
				<router-link
					class="text-2xl" 
					:class="{
						'text-gray-0 md:text-gray-9' : !route('home') 
					}" 
					
					:to="{ 
						name: 'contact' 
					}"
				>
					Kontakt
				</router-link>
			</li>
		</ul>
	</nav>
</template>

<script>
import ease from '@/components/ease';

export default {
	name: 'interface-navigation',
	components: {
		'transition-ease': ease
	}
};
</script>
